module.exports = __webpack_public_path__ + "static/media/M1_NORM.dc065ba2.png";